export default __webpack_public_path__ + "static/media/sc36.40e7ee98.jpg";